import React from 'react';
import IntroImage from '../assets/intro.png';

const IntroSection = () => {
  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex flex-col lg:flex-row items-center gap-16">
        {/* Left: Text Content */}
        <div className="flex-1 space-y-6">
          <div className="space-y-4">
            <h2 className="text-display-3 font-display font-black leading-tight tracking-tighter">
              <span className="text-brand-dark">Tư vấn & Đào tạo</span><br />
              <span className="text-brand-dark">Ứng dụng AI</span><br />
              <span className="text-gradient">Trong Doanh nghiệp</span>
              <span className="text-brand-primary ml-2">✦</span>
            </h2>
            <p className="text-body-large text-gray-700 leading-relaxed max-w-2xl font-body">
              StarAI tiên phong trong lĩnh vực tư vấn và đào tạo AI ứng dụng cho doanh nghiệp Việt Nam. Chúng tôi cung cấp giải pháp toàn diện từ phân tích mô hình vận hành đến triển khai thực tế, giúp doanh nghiệp chuyển đổi số hiệu quả.
            </p>
          </div>
          
          <div className="flex space-x-4">
            <button className="px-8 py-4 bg-brand-primary text-white font-display font-semibold text-button tracking-wide rounded-full shadow-lg hover:bg-brand-secondary transition-all">
              Tìm hiểu dịch vụ
            </button>
          </div>
        </div>
        
                 {/* Right: Illustration */}
         <div className="fl ex-1 flex justify-center">
           <div className="relative">
             <img 
               src= {IntroImage} 
               alt="AI Business Solutions" 
               className="rounded-3xl shadow-2xl w-full max-w-md object-cover"
             />
             <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-brand-primary to-brand-secondary rounded-full opacity-20"></div>
             <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-gradient-to-br from-brand-secondary to-brand-primary rounded-full opacity-20"></div>
           </div>
         </div>
      </div>
    </section>
  );
};

export default IntroSection; 